import React, { useState } from "react";
import { Container } from "react-bootstrap";
import "./Privacy.css";
import CommonBreadcrumb from "../common_components/breadcrumb/CommonBreadcrumb";
import PrivacyTab from "../shipping_policy/shipping_tab/PrivacyTab";
import PrivacyPolicy from "./shipping_p/PrivacyPolicy";

const Cart = () => {
  const [activeTab, setActiveTab] = useState("1");

  const breadcrumbItems = [
    { label: "Home", link: "/home" },
    { label: "Shipping Policy" },
  ];

  return (
    <section className="privacy-section">
      <div>
        <CommonBreadcrumb items={breadcrumbItems} />
      </div>
      <Container>
        <div className="privacy-wrapper">
          {/* Left Side */}
          <aside className="privacy-sidebar ">
            <div className="privacy-tab-sticky">
              <PrivacyTab activeTab={activeTab} setActiveTab={setActiveTab} />
            </div>
          </aside>

          {/* Right Side */}
          <div className="privacy-content">
            <PrivacyPolicy activeTab={activeTab} />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Cart;
